<!--
  Bottom-centre canvas pill (WorkspaceSceneBar.vue): previous / "1/1" / next scene and Play scenes (Lite has one scene, so
  Play opens the scenes teaser), Capture image, Zoom to all, Clear selection. The tool mode bar replaces it while a tool
  is active.
-->
<script setup lang="ts">
import Button from 'primevue/button';
import { useLiteStore } from '@nanome-lite/state';
import ToolModeBar from '@/components/ToolModeBar.vue';

const emit = defineEmits<{ capture: [event: Event]; 'scenes-teaser': [event: Event] }>();
const store = useLiteStore();
const sceneCount = 1;
</script>

<template>
  <ToolModeBar v-if="store.view.tool !== 'default'" />
  <div v-else class="flex items-center gap-1 bg-xr rd-full p-1">
    <div class="flex items-center gap-1">
      <Button icon="i-tabler-chevron-left" size="small" severity="secondary" rounded text :disabled="sceneCount <= 1" aria-label="Previous scene" />
      <span class="text-sm min-w-12 text-center" data-testid="scene-counter">1/{{ sceneCount }}</span>
      <Button icon="i-tabler-chevron-right" size="small" severity="secondary" rounded text :disabled="sceneCount <= 1" aria-label="Next scene" />
    </div>
    <Button
      v-tooltip.top="'Play scenes'"
      icon="i-tabler-player-play"
      size="small"
      severity="secondary"
      rounded
      text
      aria-label="Play scenes"
      data-testid="scenes-play"
      @click="emit('scenes-teaser', $event)"
    />
    <Button
      v-tooltip.top="'Capture image'"
      :disabled="!store.entries.length"
      icon="i-tabler-camera"
      size="small"
      severity="secondary"
      rounded
      text
      @click="emit('capture', $event)"
    />
    <Button
      v-tooltip.top="'Zoom to all'"
      :disabled="!store.entries.length"
      icon="i-tabler-search"
      size="small"
      severity="secondary"
      rounded
      text
      @click="store.zoomAll()"
    />
    <Button
      v-if="store.hasSelection"
      v-tooltip.top="'Clear selection'"
      icon="i-tabler-deselect"
      size="small"
      severity="secondary"
      rounded
      text
      @click="store.clearSelection()"
    />
  </div>
</template>
